import { currentUser } from './utils';
import { get } from 'svelte/store';

export const getToken = () => {
  return get(currentUser).accessToken ? get(currentUser).accessToken : null;
};

export const url = () => {
  return process['env'].PROD_ENV == true || process['env'].PROD_ENV == 'true'
    ? 'https://auth.shopbox.ai'
    : 'https://beta-sb-auth-vlwut6qbsq-lz.a.run.app';
};

export const createClient = (clientData) => {
  return fetch(url() + '/api/v1/clients', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(clientData),
  }).then(async (res) => {
    const json = await res.json();
    if (res.ok) {
      return json;
    } else {
      throw new Error(json.detail);
    }
  });
};

export const addWebsite = (websiteData) => {
  return fetch(url() + '/api/v1/clients/website', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(websiteData),
  }).then(async (res) => {
    const json = await res.json();
    if (res.ok) {
      return json;
    } else {
      throw new Error(json.detail);
    }
  });
};

export const updateClient = (clientData, id) => {
  return fetch(url() + '/api/v1/clients?cid=' + id, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(clientData),
  }).then(async (res) => {
    const json = await res.json();
    if (res.ok) {
      return json;
    } else {
      throw new Error(json.detail);
    }
  });
};
